import { useEffect } from 'react';

import { useProjectActions } from 'src/store';

export const useClearTovInputsOnUnmount = () => {
  const projectActions = useProjectActions();

  useEffect(() => {
    return () => projectActions.clearTovInputs();
  }, [projectActions]);
};
